"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMDTaxLabelMappings = exports.TaxLabelMappings = void 0;
var offerTypeConsts_1 = require("../consts/offerTypeConsts");
exports.TaxLabelMappings = {
    fl_doc_stamp: 'Doc Stamp',
    fl_discretionary: 'Discretionary County Tax',
    nj_supp: 'Supplemental Titling Fee',
    tx_vit: 'Vehicle Inventory Tax',
    or_privilege: 'Privilege Tax',
    or_cat: 'Corporate Activity Tax',
    va_business_license: 'Business License Tax',
    tn_business: 'Business Tax',
    tn_local_options: 'Local Options Tax',
    tn_single_article: 'Single Article Tax',
    ga_ad_valorem: 'Ad Valorem Tax',
    ct_tradein_fee: 'Trade-In Fee',
    wa_esc: 'Warranty Tax',
    wa_rta: 'Regional Transit Authority Tax',
    mn_excise_tax: 'Excise Tax',
    stateTax: 'State',
    countyTax: 'County',
    cityTax: 'City',
    localTax: 'Local'
};
exports.AMDTaxLabelMappings = {
    stateTax: 'State Tax',
    countyTax: 'County Tax',
    cityTax: 'City Tax',
    localTax: 'Local Tax'
};
